export const legalData = {
  termsText: `<div class="sqs-html-content">
  <h2 style="text-align: center; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0732824s;" data-rte-preserve-empty="true" class="preFade fadeIn"></h2><h2 style="text-align: center; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0778626s;" class="preFade fadeIn"><strong>Terms and Conditions of Service</strong></h2><p style="text-align: center; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0824427s;" class="preFade fadeIn"><em>Last Updated: January 1, 2025</em><strong> </strong></p><p style="text-align: center; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0870229s;" class="preFade fadeIn"><strong>KNOW HEALTHTECH, INC.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0916031s;"><strong>Please read these Terms and Conditions of Service (these “Terms”) carefully as they contain important information about your rights, remedies, and obligations. By accessing or using the Sites (as hereinafter defined), you agree to comply with and be bound by these Terms.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0961832s;">By using or accessing the app and/or other online products or services provided by Know Healthtech, Inc. (“Know Rare”, “Health Story AI”, “we”, “us”, or “our”), on which these Terms are posted via a link or otherwise (each referred to herein as a “Site” and collectively as “Sites”), you acknowledge and agree that these Terms govern your access to and use of the Sites.Our <a href="https://knowrare.com/privacy">Privacy Policy</a> and other policies applicable to our collection and use of personal information in connection with your access to and use of the Know Rare Services, including the Sites, are incorporated by reference into these Terms.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.100763s;">Our <a href="/privacy" target="_blank">Privacy Policy</a> and other policies applicable to our collection and use of Personal Data and other data in connection with the Sites are incorporated by reference into these Terms.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.105344s;"><span style="text-decoration:underline">ARBITRATION NOTICE</span>:&nbsp; These Terms contain a binding arbitration provision, and waiver of jury trials and class actions, governing disputes arising from your use of the Sites.&nbsp; Please see Section 13 below for more information. By accessing the Sites, you accept and agree to this arbitration clause and class action and jury waiver. Please read it carefully.</p><p class="preFade fadeIn" data-rte-preserve-empty="true" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.109924s;"></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.114504s;"><span style="text-decoration:underline"><strong>1. Scope of the Sites</strong></span><strong>.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.119084s;">1.1 The Sites comprise certain proprietary technology services that assist you in finding and learning about clinical studies appropriate for your medical condition, help you schedule screening visits for a clinical research project (a “Research Study”) and, with your consent, forwards your health-related information to a study center.&nbsp; The Sites also comprise certain app features/services that allow you to use mental health journals, take surveys regarding your mental health, receive analytics reports about your use of the app and connect with mental health guides. These app features/services are referred to collectively as “StoryCatch”.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.123664s;">You agree that if you choose to receive service-related notifications relating to the Sites and/or your use thereof, Know Rare may send you such notifications.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.128244s;"><span style="text-decoration:underline"><strong>2 . Disclaimers</strong></span><strong>.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.132824s;">2.1Know Rare is not a health care provider and does not provide medical advice. All information, materials and services made available to you through the Sites, including, without limitation, information shared via Know Rare’s website, app (including but not limited to StoryCatch features/services), app blog, social channels, emails and text messages, and Know Rare advertising is for informational purposes only and may not be relied on as medical advice. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.137405s;">2.2 KNOW RARE EXPRESSLY DISCLAIMS ANY EXPRESS OR IMPLIED GUARANTEE OR WARRANTY REGARDING THE ACCURACY, COMPLETENESS, TIMELINESS, OR RELEVANCE OF ANY INFORMATION PROVIDED THROUGH THE SITES.&nbsp;YOU ACKNOWLEDGE AND AGREE THAT TO THE EXTENT YOU RELY ON ANY SUCH INFORMATION, YOU DO SO SOLELY AT YOUR OWN RISK. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.141985s;">2.3 Know Rare does not recommend or endorse any specific Research Studies. You are responsible for choosing whether or not to participate in any Research Study, including without limitation, determining the risks and benefits associated with participating in a Research Study.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.146565s;"><span style="text-decoration:underline"><strong>3. Modifications to Terms</strong></span><strong>.&nbsp;&nbsp;</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.151145s;">Know Rare reserves the right, at its sole discretion, to change, modify, add or remove any portion of these Terms, in whole or in part, at any time.&nbsp; It is your responsibility to check periodically for any changes we make to these Terms. Your continued use of the Sites after any changes to these Terms or other policies means you accept the changes.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.155725s;"><span style="text-decoration:underline"><strong>4. Eligibility/Age Restrictions.</strong></span></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.160305s;">You must be 18 years of age or older to use the Sites. By using the Sites, you represent that you are at least 18 years of age. To make use of the Sites on behalf of a minor or an adult who has a legal guardian, you must be the legal guardian, or an individual with uncontested legal authority to agree to these Terms on such person’s behalf. &nbsp; By using the Sites for a person who has a legal guardian, you represent that you have such legal authority.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.164885s;"><span style="text-decoration:underline"><strong>5. Prohibited Activities; No reverse engineering, etc.</strong></span></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.169466s;">You are granted a limited, revocable, non-exclusive license to access the Sites solely for the purposes permitted by, and in accordance with, these Terms. Any use of the Sites that is not for purposes expressly permitted herein or otherwise authorized by us in writing is expressly prohibited.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.174046s;">Your license to use the Sites only extends to the uses expressly described herein. You acknowledge and agree that we are entitled to deny your use of the Sites at any time in our sole and unfettered discretion.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.178626s;">You do not have any right of collection, aggregation, copying, scraping, duplication, display or any derivative use of the Sites nor any right of use of data mining, robots, spiders or similar data gathering and extraction tools without our prior written permission, other than for the sole purpose of displaying hyperlinks to the Sites by internet search engines, provided they each do so from a stable IP address or range of IP addresses using an easily identifiable agent.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.183206s;">You may only access the Sites using authorized means. It is your responsibility to check to ensure you download the correct application for your device. We are not liable if you do not have a compatible device or if you download the wrong version of the application for your device.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.187786s;">By accessing or using the Sites, you further represent and warrant that:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.192366s;">All information you provide to us is accurate and complete;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.196947s;">You will only use the Sites for your sole, personal use (or for use on behalf of another person to the extent you are legally authorized, as described herein);</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.201527s;">You will not copy, distribute or reverse engineer the Sites or any portion thereof;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.206107s;">You will not upload or transmit any communications or content of any type that infringes or violates any rights of any party;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.210687s;">You will not use the Sites for any purpose in violation of local, state, federal or international laws; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.215267s;">You will not use the Sites as a means to distribute advertising or other unsolicited material to any third-party; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.219847s;">You will not impersonate another person; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.224427s;">You will not post material that is unlawful, obscene, defamatory, threatening, harassing, abusive, slanderous, hateful or embarrassing to any other person or entity as determined by us in our sole discretion; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.229008s;">You will comply with all applicable third-party terms of agreement when using the Sites (e.g., your wireless data service agreement); </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.233588s;">You will ensure that no unauthorized person shall have access to your mobile device or the passwords or accounts you use to access the Sites, and you will promptly notify us in the event your passwords or accounts have been compromised; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.238168s;">You will not assign or otherwise transfer your account to any other person or entity; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.242748s;">You will not try to harm the Sites or impair the proper operation of the Sites in any way whatsoever; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.247328s;">You will provide us with proof of your identity as may be requested by us; and</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.251908s;">You will abide by all laws, rules and regulations applicable to your use of the Sites, and to any transaction that you enter into on or in connection your use of the Sites.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.256489s;">We reserve the right to immediately terminate your license to use the Sites should you fail to comply with any of the foregoing representations and warranties.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.261069s;"><span style="text-decoration:underline"><strong>6. Content and Right to Use</strong></span><strong>.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.265649s;">You acknowledge that you are responsible for any material you submit on or via any Sites, including the legality, reliability, appropriateness, originality and copyright of any such material.&nbsp; You may not upload to, distribute or otherwise publish through any Sites any content that (i) is false, fraudulent, libelous, defamatory, obscene, threatening, violative of any third party’s confidentiality, privacy or publicity rights, infringing on intellectual property rights, abusive, illegal or otherwise objectionable, (ii) may constitute or encourage a criminal offense, violate the rights of any party or otherwise give rise to liability or violate any law, or (iii) may contain software viruses, political campaigning, chain letters, mass mailings or any form of “spam.”&nbsp; You may not use a false email address or other false identifying information, impersonate any person or entity or otherwise mislead as to the origin of any information that you provide when using any Sites.&nbsp; You may not upload commercial content onto or via any Sites.&nbsp; If you do submit material, and unless we indicate otherwise or as otherwise specified in our Privacy Policy, you grant Know Rare and its affiliates an unrestricted, non-exclusive, royalty- free, perpetual, irrevocable and fully sub-licensable right to use, reproduce, modify, adapt, publish, translate, create derivative works from, distribute and display such material throughout the world in any media.&nbsp; You further agree that Know Rare is free to use any ideas, feedback, concepts, or know-how that you or individuals acting on your behalf provide to Know Rare.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.270229s;">You grant Know Rare and its subsidiaries the right to use the name you submit in connection with such material, if we so choose, and subject to our Privacy Policy.&nbsp; You represent and warrant that you own or otherwise control all the rights to the content you post; that the content is accurate; that use of the content you supply does not violate any provision herein and will not cause injury to any person or entity; and that you will indemnify and hold harmless Know Rare for all claims resulting from content you supply.&nbsp; With respect to any material you submit, we have the right to:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.274809s;">Remove or refuse to post any such material for any or no reason in our sole and unfettered discretion;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.279389s;">Take any action with respect to any such material that we deem necessary or appropriate in our sole discretion; including if we believe that such material violates these Terms, infringes any intellectual property right or other right of any person or entity, threatens the personal safety of users of the Sites or the public or could create liability for Know Rare; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.283969s;">As legally permitted, disclose your identity or other information about you to any third-party who claims that material posted by you violates their rights, including their intellectual property rights or their right to privacy; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.28855s;">Take appropriate legal action, including without limitation, referral to law enforcement, for any illegal or unauthorized use of the Sites; and </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.29313s;">Terminate or suspend your access to all or part of the Sites for any or no reason, including without limitation, any violation of these Terms.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.29771s;">Without limiting the foregoing, we reserve the right to fully cooperate with any law enforcement authorities or court order requesting or directing us to disclose the identity or other information of anyone posting any materials on or through the Sites.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.30229s;">The Sites are controlled and operated by Know Rare or an affiliate of Know Rare in the United States. Any software or applications available on the Sites is subject to United States export controls. No software available on the Sites may be downloaded or otherwise exported or re-exported to (i) any country to which the United States has embargoed goods, or (ii) anyone on the United States Treasury Department’s list of Specially Designated Nationals or the United States Commerce Department’s Table of Deny Orders. By using the Sites, you represent and warrant that you are not located in, under the control of, or a national or resident of any such country or on any such list.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.30687s;"><span style="text-decoration:underline"><strong>7. Third-Party Materials</strong></span><strong>.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.31145s;">The Sites may link to websites, products, and/or services of third parties (collectively, “Third Party Materials”).&nbsp; These links are provided as a convenience to you and as an additional avenue of access to the Third Party Materials.&nbsp; We are not responsible for the content of any Third Party Materials. Inclusion of links to Third Party Materials should not be viewed as our endorsement of the Third Party Materials.&nbsp; Different terms and conditions may apply to your use of any Third Party Materials. Know Rare is not responsible for any losses, damages or other liabilities incurred as a result of your use of any Third Party Materials.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.316031s;"><span style="text-decoration:underline"><strong>8. Disclaimers of Warranties</strong></span><strong>.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.320611s;">YOUR USE OF THE SITES IS AT YOUR SOLE RISK. THE SITES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. WE RESERVE THE RIGHT TO RESTRICT OR TERMINATE YOUR ACCESS TO THE SITES OR ANY FEATURE OR PART THEREOF AT ANY TIME. KNOW RARE EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE AND ANY WARRANTIES THAT MATERIALS ON OR ASSOCIATED WITH THE SITES ARE NON INFRINGING, AS WELL AS WARRANTIES IMPLIED FROM A COURSE OF PERFORMANCE OR COURSE OF DEALING; THAT ACCESS TO THE SITES WILL BE UNINTERRUPTED OR ERROR-FREE; THAT THE SITES WILL BE SECURE; THAT THE SITES OR THE SERVERS THAT MAKE THE SITES AVAILABLE WILL BE VIRUS-FREE; OR THAT INFORMATION ON OR ASSOCIATED WITH THE SITES WILL BE COMPLETE, ACCURATE OR TIMELY. IF YOU DOWNLOAD ANY MATERIALS FROM THE SITES, YOU DO SO AT YOUR OWN DISCRETION AND RISK. YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR MOBILE DEVICE OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY SUCH MATERIALS. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM KNOW RARE OR THROUGH OR FROM THE SITES SHALL CREATE ANY WARRANTY OF ANY KIND.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.325191s;">IN CERTAIN JURISDICTIONS, THE LAW MAY NOT PERMIT THE DISCLAIMER OF WARRANTIES, IN WHICH CASE THE ABOVE DISCLAIMER MAY NOT APPLY TO YOU.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.329771s;"><span style="text-decoration:underline"><strong>9. Limitations on Liability</strong></span><strong>.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.334351s;">YOU ACKNOWLEDGE AND AGREE THAT YOU ASSUME FULL RESPONSIBILITY FOR YOUR USE OF THE SITES. YOU ACKNOWLEDGE AND AGREE THAT ANY INFORMATION YOU SEND OR RECEIVE DURING YOUR USE OF THE SITES MAY NOT BE SECURE AND MAY BE INTERCEPTED BY UNAUTHORIZED PARTIES. YOU ACKNOWLEDGE AND AGREE THAT YOUR USE OF THE SITES IS AT YOUR OWN RISK. RECOGNIZING SUCH, YOU ACKNOWLEDGE AND AGREE THAT, TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, NEITHER KNOW RARE NOR ITS AFFILIATES, SUPPLIERS OR THIRD- PARTY CONTENT PROVIDERS WILL BE LIABLE FOR ANY DIRECT, INDIRECT, PUNITIVE, EXEMPLARY, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR OTHER DAMAGES ARISING OUT OF OR IN ANY WAY RELATED TO THE SITES, OR FROM ANY ACTIONS WE TAKE OR FAIL TO TAKE AS A RESULT OF COMMUNICATIONS YOU SEND TO US, OR THE DELAY OR INABILITY TO USE THE SITES, OR FOR ANY INFORMATION, PRODUCTS OR KNOW RARE SERVICES ADVERTISED IN OR OBTAINED THROUGH THE SITES, KNOW RARE’S REMOVAL OR DELETION OF ANY MATERIALS SUBMITTED OR POSTED ON THE SITES, OR OTHERWISE ARISING OUT OF THE USE OF THE SITES, WHETHER BASED ON CONTRACT, TORT, STRICT LIABILITY OR OTHERWISE, EVEN IF KNOW RARE, ITS AFFILIATES OR ANY OF ITS SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES. THIS DISCLAIMER APPLIES, WITHOUT LIMITATION, TO ANY DAMAGES OR INJURY ARISING FROM ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DELETION, DEFECTS, DELAY IN OPERATION OR TRANSMISSION, COMPUTER VIRUSES, FILE CORRUPTION, COMMUNICATION-LINE FAILURE, NETWORK OR SYSTEM OUTAGE, YOUR LOSS OF PROFITS, OR THEFT, DESTRUCTION, UNAUTHORIZED ACCESS TO, ALTERATION OF, LOSS OR USE OF ANY RECORD OR DATA, AND ANY OTHER TANGIBLE OR INTANGIBLE LOSS. YOU SPECIFICALLY ACKNOWLEDGE AND AGREE THAT NEITHER KNOW RARE NOR ITS AFFILIATES, SUBSIDIARIES OR SUPPLIERS SHALL BE LIABLE FOR ANY DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF ANY USER OF THE SITES. YOUR SOLE AND EXCLUSIVE REMEDY FOR ANY OF THE ABOVE CLAIMS OR ANY DISPUTE WITH KNOW RARE IS TO DISCONTINUE YOUR USE OF THE SITES. YOU AND KNOW RARE AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SITES MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES OR THE CAUSE OF ACTION IS PERMANENTLY BARRED. BECAUSE SOME JURISDICTIONS DO NOT ALLOW LIMITATIONS ON HOW LONG AN IMPLIED WARRANTY LASTS, OR THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, ALL OR A PORTION OF THE ABOVE LIMITATION MAY NOT APPLY TO YOU.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.338931s;"><span style="text-decoration:underline"><strong>10. Interaction with Other Users</strong></span>.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.343511s;">You agree that, with respect to other users’ Personal Data that you may obtain from or through the Sites or through any Site-related communication, transaction or software, your license to use such Personal Data is limited to: (i) Site-related communications that are not unsolicited commercial messages, and (ii) using services offered through the Sites. You may not use any such Personal Data for any unlawful purpose or with any unlawful intent.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.348092s;">Except to the extent you are legally authorized to do so, you may not disclose any Personal Data about another user to any third-party. You agree and consent to other users using Personal Data that you’ve shared with them to communicate with you in accordance with this provision. You agree that you will protect other users’ Personal Data with the same degree of care that you protect your own confidential information (using at minimum a reasonable standard of care), and you hereby assume all liability for any misuse, loss or unauthorized transfer of such information.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.352672s;">Without limiting the foregoing, you are not permitted to add another user to your mailing list, database or other records without such user’s express consent. You may not use any tool or service on the Sites to send spam or unsolicited communications of any kind or in any other way that would violate these Terms.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.357252s;"><span style="text-decoration:underline"><strong>11. Indemnification</strong></span><strong>.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.361832s;">You agree to indemnify, defend and hold harmless Know Rare and its affiliates and their officers, directors, employees, contractors, agents, licensors, service providers, subcontractors and suppliers from and against any and all losses, liabilities, expenses, damages and costs, including reasonable attorneys’ fees and court costs, arising or resulting from your use of the Sites, your breach of these Terms or the documents referenced herein, or your violation of any law or rights of a third-party. If you cause a technical disruption of the Sites or the systems transmitting the Sites to you or others, you agree to be responsible for any and all losses, liabilities, expenses, damages and costs, including reasonable attorneys’ fees and court costs, arising or resulting from that disruption.&nbsp; Know Rare reserves the right, at its own expense, to assume exclusive defense and control of any matter otherwise subject to indemnification by you and, in such case, you agree to cooperate with Know Rare in the defense of such matter.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.366412s;"><span style="text-decoration:underline"><strong>12. Notice of Copyright Infringement.</strong></span></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.370992s;">You are hereby informed that Know Rare has adopted and reasonably implemented a policy that provides for the termination, in appropriate circumstances, of users of the Sites who are repeat copyright infringers.&nbsp; If you believe your copyright or the copyright of a person on whose behalf you are authorized to act has been infringed, you may notify our copyright agent:</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.375573s;">Email: ________________</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.380153s;">Address: ______________</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.384733s;">To be effective, your notification must (1) be in writing, (2) be provided to our copyright agent, and (3) include substantially the following: (a) A physical or electronic signature of a person authorized to act on behalf of the owner of an exclusive right that is allegedly infringed; (b) Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted works at a single online site are covered by a single notification, a representative list of such works at that site; (c) Identification of the material that is claimed to be infringing or to be the subject of infringing activity and that is to be removed or access to which is to be disabled, and information reasonably sufficient to permit us or our agents to locate the material; (d) Information reasonably sufficient to permit us or our agents to contact the complaining party, such as an address, telephone number, and, if available, an electronic mail address at which the complaining party may be contacted; (e) A statement that the complaining party has a good faith belief that use of the material in the manner complained of is not authorized by the copyright owner, its agent or the law; and (f) A statement that the information in the notification is accurate, and under penalty of perjury, that the complaining party is authorized to act on behalf of the owner of an exclusive right that is allegedly infringed.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.389313s;"><strong>PLEASE READ THE FOLLOWING SECTION CAREFULLY. IT AFFECTS YOUR LEGAL RIGHTS, INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT.</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.393893s;"><span style="text-decoration:underline"><strong>13. Mandatory Arbitration, Waiver of Class Actions</strong></span><strong>.</strong></p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.398473s;" class="preFade fadeIn"><span style="text-decoration:underline">13.1 In General</span>.&nbsp; By using or accessing the Sites you agree that these Terms affect interstate commerce and that the Federal Arbitration Act governs the interpretation and enforcement of these arbitration provisions.&nbsp; This <span style="text-decoration:underline">Section 13</span> is intended to be interpreted broadly and governs any and all disputes between us including, but not limited to, claims arising out of or relating to any aspect of the relationship between us, whether based in contract, tort, statute, fraud, misrepresentation or any other legal theory; claims that arose before these Terms or any prior terms; and claims that may arise after the termination of these Terms.&nbsp; The only disputes excluded from mandatory arbitration are the litigation of certain intellectual property rights as provided below.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.403053s;" class="preFade fadeIn"><span style="text-decoration:underline">13.2 Initial Dispute Resolution</span>.&nbsp; Most disputes can be resolved without resort to arbitration. If you have any dispute with us in connection with your access and use of the Sites, you agree that before taking any formal action, you will contact us at jake@knowrare.com, and provide a brief, written description of the dispute and your contact information. Except for intellectual property, you and Know Rare agree to use reasonable, good faith efforts to resolve any dispute, claim, question or disagreement informally through consultation between you and Know Rare .</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.407634s;" class="preFade fadeIn"><span style="text-decoration:underline">13.3 Binding Arbitration</span>.&nbsp; If the parties to a dispute do not reach an agreed- upon solution within a period of thirty (30) days from the time informal dispute resolution is initiated as provided above, then either party may initiate binding arbitration as the sole means to resolve claims (except as otherwise provided herein) subject to these Terms.&nbsp; Specifically, all claims arising out of or relating to these Terms, the parties’ relationship with each other and/or your use of the Sites shall be finally settled by binding arbitration administered by JAMS in accordance with the JAMS Streamlined Arbitration Procedure Rules for claims that do not exceed $250,000 and the JAMS Comprehensive Arbitration Rules and Procedures for claims exceeding $250,000 in effect at the time the arbitration is initiated, excluding any rules or procedures governing, or permitting class actions.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.412214s;" class="preFade fadeIn"><span style="text-decoration:underline">13.4 Arbitrator’s Powers</span>.&nbsp; The arbitrator, and not any federal, state or local court or agency, shall have exclusive authority to resolve all disputes arising out of or relating to the interpretation, applicability, enforceability or formation of these Terms, including, but not limited to, any claim that all or any part of these Terms are void or voidable, whether a claim is subject to arbitration or the question of waiver by litigation conduct. The arbitrator shall be empowered to grant whatever relief would be available in a court under law or in equity. The arbitrator’s award shall be written and shall be binding on the parties and may be entered as a judgment in any court of competent jurisdiction.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.416794s;" class="preFade fadeIn"><span style="text-decoration:underline">13.5 No Jury Trial</span>.&nbsp; If for any reason a claim proceeds in court rather than in arbitration, you and Know Rare each agree to waive any right to a jury trial.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.421374s;" class="preFade fadeIn"><span style="text-decoration:underline">13.6 Venue</span>.&nbsp; Arbitration shall be initiated and take place in New York County, New York, United States, and you and Know Rare agree to submit to the personal jurisdiction of any federal or state court in New York, New York, in order to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate or enter judgment on the award entered by the arbitrator.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.425954s;" class="preFade fadeIn"><span style="text-decoration:underline">13.7 Class Action Waiver</span>.&nbsp; You agree that the arbitration shall be conducted in your individual capacity only and not as a class action or other representative action, and you expressly waive your right to file a class action or seek relief on a class basis. YOU AGREE THAT EACH PARTY TO THESE TERMS MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING. If any court or arbitrator determines that the class action waiver set forth in this paragraph is void or unenforceable for any reason or that an arbitration can proceed on a class basis, then the arbitration provisions set forth above shall be deemed null and void in their entirety and the parties shall be deemed to have not agreed to arbitrate disputes.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.430534s;" class="preFade fadeIn"><span style="text-decoration:underline">13.8 Exception: Litigation of Intellectual Property</span>.&nbsp; Notwithstanding the parties’ decision to resolve all disputes through arbitration, either party may bring enforcement actions, validity determinations or claims arising from or relating to theft, piracy or unauthorized use of intellectual property in state or federal court with jurisdiction or in the U.S. Patent and Trademark Office to protect its intellectual property rights.&nbsp; The term “intellectual property rights” means patents, copyrights, moral rights, trademarks and trade secrets, but not privacy or publicity rights.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.435115s;" class="preFade fadeIn"><span style="text-decoration:underline">13.9 Survival</span>.&nbsp; This Mandatory Arbitration, Waiver of Class Actions Section shall survive any termination of your use of the Sites.</p><p class="preFade fadeIn" data-rte-preserve-empty="true" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.439695s;"></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.444275s;"><span style="text-decoration:underline"><strong>14. General</strong></span><strong>.</strong></p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.448855s;" class="preFade fadeIn"><span style="text-decoration:underline">14.1 Governing Law; Jurisdiction</span>.&nbsp; The laws of the State of New York shall govern the validity and construction of these Terms and any dispute arising out of or relating to these Terms, without regard to the principles of conflict of laws. For any matters specifically excluded from the Mandatory Arbitration Provision above (Section 13), the parties agree to submit to the jurisdiction of any court of record of the State of New York in the County of New York or a United States District Court in the Southern District of the State of New York in any legal proceeding instituted by either party arising out of or relating to these Terms.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.453435s;" class="preFade fadeIn"><span style="text-decoration:underline">14.2 Compliance with Applicable Law</span>. You are responsible for informing yourself of the laws of your jurisdiction and complying with them.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.458015s;" class="preFade fadeIn"><span style="text-decoration:underline">14.3 Assignment</span>.&nbsp; You may not assign or transfer, by operation of law or otherwise, any of your rights or obligations under these Terms to any third- party without Know Rare’ prior written consent. Any attempted assignment or transfer in violation of the foregoing will be void.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.462595s;" class="preFade fadeIn"><span style="text-decoration:underline">14.4 Survival</span>.&nbsp; The provisions of <span style="text-decoration:underline">Sections 5, 6, 8, 9, 10, 11, 13 and 14</span>, in addition to any other provisions of these Terms and any supplemental legal document executed between the parties shall survive termination of these Terms.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.467176s;" class="preFade fadeIn"><span style="text-decoration:underline">14.5 Notices</span>.&nbsp; Notices under these Terms shall be sent as follows: If to Know Rare, such notice or report shall be sent to jake@knowrare.com. If to you, such notice or report shall be sent to the email address you provided when accessing the Sites and shall suffice as proper notice under this section. Notice via electronic mail shall be deemed received on the day sent by Know Rare. Non-electronic mail notice shall also be deemed given: (i) upon receipt if by personal delivery; (ii) upon receipt if sent by certified or registered mail (return receipt requested); or (iii) one day after it is sent if by next day delivery by a major commercial delivery service.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.471756s;" class="preFade fadeIn"><span style="text-decoration:underline">14.6 Force Majeure</span>.&nbsp; Neither party shall be liable to the other for any delay or failure to perform any obligation under these Terms (except for a failure to pay fees) if the delay or failure is due to unforeseen events, which occur after the signing of these Terms and which are beyond the reasonable control of the parties, such as strikes, blockade, war, terrorism, riots, natural disasters, epidemics, refusal of license by the government or other governmental agencies, in so far as such an event prevents or delays the affected party from fulfilling its obligations and such party is not able to prevent or remove the force majeure at reasonable cost.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.476336s;" class="preFade fadeIn"><span style="text-decoration:underline">14.7 Severability</span>.&nbsp; Whenever possible each provision of these Terms shall be interpreted in such manner as to be effective and valid under applicable law, but if any term or provision of these Terms, or the application of any such term or provision to any person or circumstances shall, to any extent, be prohibited by or invalid or unenforceable under applicable law, such term or provision shall be ineffective to the extent of such prohibition, invalidity or unenforceability, without invalidating the remainder of such term or provision, the application of such term or provision to persons or circumstances other than those as to which it is held prohibited, invalid or unenforceable or the remaining terms and provisions of these Terms.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.480916s;" class="preFade fadeIn"><span style="text-decoration:underline">14.8 Waiver</span>.&nbsp; No waiver will be implied from conduct or failure to enforce or exercise rights under these Terms, nor will any waiver be effective unless in a writing signed by a duly authorized representative on behalf of the party claimed to have waived.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.485496s;" class="preFade fadeIn"><span style="text-decoration:underline">14.9 Headings</span>.&nbsp; The headings preceding the text of the paragraphs of these Terms are intended and inserted solely for the convenience of reference and shall not affect the meaning, interpretation, construction or effect of these Terms.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.490076s;" class="preFade fadeIn"><span style="text-decoration:underline">14.10 Entire Agreement</span>.&nbsp; These Terms constitute the entire agreement and understanding between you and Know Rare with respect to the subject matter herein and supersede all prior or contemporaneous communications and proposals, whether oral or written, between the parties with respect to such subject matter. A printed version of these Terms shall be admissible in judicial or administrative proceedings based on or relating to use of the Sites to the same extent and subject to the same conditions as other business documents and records originally generated and maintained in printed form.</p>
</div>`,
  privacyText: `<div class="content">
      
      
      
      
      
      
      
      
      <div data-fluid-engine="true"><style>

.fe-677c137a7d41546d3e83ebcb {
  --grid-gutter: calc(var(--sqs-mobile-site-gutter, 6vw) - 11.0px);
  --cell-max-width: calc( ( var(--sqs-site-max-width, 1500px) - (11.0px * (8 - 1)) ) / 8 );

  display: grid;
  position: relative;
  grid-area: 1/1/-1/-1;
  grid-template-rows: repeat(225,minmax(24px, auto));
  grid-template-columns:
    minmax(var(--grid-gutter), 1fr)
    repeat(8, minmax(0, var(--cell-max-width)))
    minmax(var(--grid-gutter), 1fr);
  row-gap: 11.0px;
  column-gap: 11.0px;
}

@media (min-width: 768px) {
  .background-width--inset .fe-677c137a7d41546d3e83ebcb {
    --inset-padding: calc(var(--sqs-site-gutter) * 2);
  }

  .fe-677c137a7d41546d3e83ebcb {
    --grid-gutter: calc(var(--sqs-site-gutter, 4vw) - 11.0px);
    --cell-max-width: calc( ( var(--sqs-site-max-width, 1500px) - (11.0px * (24 - 1)) ) / 24 );
    --inset-padding: 0vw;

    --row-height-scaling-factor: 0.0215;
    --container-width: min(var(--sqs-site-max-width, 1500px), calc(100vw - var(--sqs-site-gutter, 4vw) * 2 - var(--inset-padding) ));

    grid-template-rows: repeat(299,minmax(calc(var(--container-width) * var(--row-height-scaling-factor)), auto));
    grid-template-columns:
      minmax(var(--grid-gutter), 1fr)
      repeat(24, minmax(0, var(--cell-max-width)))
      minmax(var(--grid-gutter), 1fr);
  }
}


  .fe-block-677c137a03baa38fe16bfef6 {
    grid-area: 1/2/5/10;
    z-index: 0;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-677c137a03baa38fe16bfef6 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-677c137a03baa38fe16bfef6 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-677c137a03baa38fe16bfef6 {
      grid-area: 1/2/5/26;
      z-index: 0;

      
        
      
    }

    .fe-block-677c137a03baa38fe16bfef6 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-677c137a03baa38fe16bfef6 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-677c137a23a67f368ca40cd5 {
    grid-area: 6/2/7/10;
    z-index: 1;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-677c137a23a67f368ca40cd5 .sqs-block {
    justify-content: center;
  }

  .fe-block-677c137a23a67f368ca40cd5 .sqs-block-alignment-wrapper {
    align-items: center;
  }

  @media (min-width: 768px) {
    .fe-block-677c137a23a67f368ca40cd5 {
      grid-area: 5/2/6/26;
      z-index: 1;

      
        
      
    }

    .fe-block-677c137a23a67f368ca40cd5 .sqs-block {
      justify-content: center;
    }

    .fe-block-677c137a23a67f368ca40cd5 .sqs-block-alignment-wrapper {
      align-items: center;
    }
  }

  .fe-block-677c137a453cb625d377f836 {
    grid-area: 7/2/37/10;
    z-index: 2;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-677c137a453cb625d377f836 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-677c137a453cb625d377f836 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-677c137a453cb625d377f836 {
      grid-area: 7/2/32/26;
      z-index: 2;

      
        
      
    }

    .fe-block-677c137a453cb625d377f836 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-677c137a453cb625d377f836 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-677c137af7c7b60fb58a6fcf {
    grid-area: 38/2/39/10;
    z-index: 3;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-677c137af7c7b60fb58a6fcf .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-677c137af7c7b60fb58a6fcf .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-677c137af7c7b60fb58a6fcf {
      grid-area: 32/2/33/26;
      z-index: 3;

      
        
      
    }

    .fe-block-677c137af7c7b60fb58a6fcf .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-677c137af7c7b60fb58a6fcf .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-677c137abec535c48123a6e1 {
    grid-area: 40/2/81/10;
    z-index: 4;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-677c137abec535c48123a6e1 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-677c137abec535c48123a6e1 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-677c137abec535c48123a6e1 {
      grid-area: 33/2/41/26;
      z-index: 4;

      
        
      
    }

    .fe-block-677c137abec535c48123a6e1 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-677c137abec535c48123a6e1 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-677c137a8ee472804dd4f0da {
    grid-area: 81/2/82/10;
    z-index: 5;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-677c137a8ee472804dd4f0da .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-677c137a8ee472804dd4f0da .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-677c137a8ee472804dd4f0da {
      grid-area: 40/2/41/26;
      z-index: 5;

      
        
      
    }

    .fe-block-677c137a8ee472804dd4f0da .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-677c137a8ee472804dd4f0da .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-677c137a29825f4f36ae9159 {
    grid-area: 83/2/97/10;
    z-index: 6;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-677c137a29825f4f36ae9159 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-677c137a29825f4f36ae9159 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-677c137a29825f4f36ae9159 {
      grid-area: 41/2/63/26;
      z-index: 6;

      
        
      
    }

    .fe-block-677c137a29825f4f36ae9159 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-677c137a29825f4f36ae9159 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_287416 {
    grid-area: 97/2/103/10;
    z-index: 8;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_287416 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_287416 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_287416 {
      grid-area: 63/2/64/10;
      z-index: 8;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_287416 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_287416 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_257127 {
    grid-area: 103/2/105/10;
    z-index: 7;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_257127 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_257127 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_257127 {
      grid-area: 64/2/73/26;
      z-index: 7;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_257127 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_257127 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_371061 {
    grid-area: 105/2/111/10;
    z-index: 10;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_371061 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_371061 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_371061 {
      grid-area: 73/2/74/11;
      z-index: 10;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_371061 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_371061 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_299790 {
    grid-area: 111/2/113/10;
    z-index: 9;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_299790 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_299790 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_299790 {
      grid-area: 74/2/95/26;
      z-index: 9;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_299790 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_299790 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_396126 {
    grid-area: 113/2/119/10;
    z-index: 11;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_396126 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_396126 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_396126 {
      grid-area: 94/2/95/11;
      z-index: 11;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_396126 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_396126 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_404132 {
    grid-area: 119/2/121/10;
    z-index: 12;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_404132 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_404132 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_404132 {
      grid-area: 96/2/116/26;
      z-index: 12;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_404132 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_404132 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_476435 {
    grid-area: 121/2/127/10;
    z-index: 14;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_476435 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_476435 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_476435 {
      grid-area: 117/2/118/14;
      z-index: 14;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_476435 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_476435 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_465919 {
    grid-area: 127/2/129/10;
    z-index: 13;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_465919 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_465919 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_465919 {
      grid-area: 118/2/129/26;
      z-index: 13;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_465919 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_465919 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_548357 {
    grid-area: 129/2/135/10;
    z-index: 16;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_548357 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_548357 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_548357 {
      grid-area: 129/2/130/11;
      z-index: 16;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_548357 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_548357 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_525053 {
    grid-area: 135/2/137/10;
    z-index: 15;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_525053 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_525053 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_525053 {
      grid-area: 130/2/135/26;
      z-index: 15;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_525053 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_525053 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_620984 {
    grid-area: 137/2/143/10;
    z-index: 18;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_620984 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_620984 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_620984 {
      grid-area: 135/2/136/13;
      z-index: 18;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_620984 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_620984 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_572277 {
    grid-area: 143/2/145/10;
    z-index: 17;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_572277 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_572277 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_572277 {
      grid-area: 136/2/147/26;
      z-index: 17;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_572277 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_572277 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_703509 {
    grid-area: 145/2/151/10;
    z-index: 20;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_703509 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_703509 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_703509 {
      grid-area: 148/2/149/12;
      z-index: 20;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_703509 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_703509 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_673017 {
    grid-area: 151/2/153/10;
    z-index: 19;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_673017 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_673017 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_673017 {
      grid-area: 149/2/155/26;
      z-index: 19;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_673017 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_673017 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_799963 {
    grid-area: 153/2/159/10;
    z-index: 22;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_799963 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_799963 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_799963 {
      grid-area: 155/2/156/12;
      z-index: 22;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_799963 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_799963 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_762629 {
    grid-area: 159/2/161/10;
    z-index: 21;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_762629 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_762629 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_762629 {
      grid-area: 156/2/172/26;
      z-index: 21;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_762629 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_762629 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_918654 {
    grid-area: 161/2/167/10;
    z-index: 24;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_918654 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_918654 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_918654 {
      grid-area: 173/2/174/15;
      z-index: 24;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_918654 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_918654 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_863741 {
    grid-area: 167/2/169/10;
    z-index: 23;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_863741 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_863741 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_863741 {
      grid-area: 174/2/179/26;
      z-index: 23;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_863741 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_863741 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1113583 {
    grid-area: 169/2/175/10;
    z-index: 26;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1113583 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_1113583 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_1113583 {
      grid-area: 179/2/180/12;
      z-index: 26;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_1113583 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_1113583 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1005477 {
    grid-area: 175/2/177/10;
    z-index: 25;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1005477 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_1005477 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_1005477 {
      grid-area: 180/2/186/26;
      z-index: 25;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_1005477 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_1005477 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1189769 {
    grid-area: 177/2/183/10;
    z-index: 28;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1189769 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_1189769 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_1189769 {
      grid-area: 186/2/187/12;
      z-index: 28;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_1189769 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_1189769 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1169916 {
    grid-area: 183/2/185/10;
    z-index: 27;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1169916 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_1169916 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_1169916 {
      grid-area: 187/2/192/26;
      z-index: 27;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_1169916 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_1169916 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1364625 {
    grid-area: 185/2/191/10;
    z-index: 30;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1364625 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_1364625 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_1364625 {
      grid-area: 192/2/193/12;
      z-index: 30;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_1364625 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_1364625 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1341709 {
    grid-area: 191/2/193/10;
    z-index: 29;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1341709 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_1341709 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_1341709 {
      grid-area: 193/2/198/26;
      z-index: 29;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_1341709 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_1341709 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_222473 {
    grid-area: 193/2/199/10;
    z-index: 32;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_222473 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736191766798_222473 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736191766798_222473 {
      grid-area: 198/2/199/13;
      z-index: 32;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736191766798_222473 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736191766798_222473 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1387146 {
    grid-area: 199/2/201/10;
    z-index: 31;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736173028970_1387146 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736173028970_1387146 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736173028970_1387146 {
      grid-area: 199/2/251/26;
      z-index: 31;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736173028970_1387146 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736173028970_1387146 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_372712 {
    grid-area: 201/2/207/10;
    z-index: 34;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_372712 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736191766798_372712 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736191766798_372712 {
      grid-area: 251/2/252/13;
      z-index: 34;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736191766798_372712 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736191766798_372712 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_269097 {
    grid-area: 207/2/209/10;
    z-index: 33;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_269097 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736191766798_269097 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736191766798_269097 {
      grid-area: 252/2/287/26;
      z-index: 33;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736191766798_269097 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736191766798_269097 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_688434 {
    grid-area: 209/2/215/10;
    z-index: 37;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_688434 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736191766798_688434 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736191766798_688434 {
      grid-area: 288/2/289/14;
      z-index: 37;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736191766798_688434 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736191766798_688434 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_427515 {
    grid-area: 215/2/217/10;
    z-index: 35;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_427515 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736191766798_427515 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736191766798_427515 {
      grid-area: 289/2/293/26;
      z-index: 35;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736191766798_427515 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736191766798_427515 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_974703 {
    grid-area: 217/2/223/10;
    z-index: 38;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_974703 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736191766798_974703 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736191766798_974703 {
      grid-area: 294/2/295/12;
      z-index: 38;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736191766798_974703 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736191766798_974703 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_659991 {
    grid-area: 223/2/225/10;
    z-index: 36;

    @media (max-width: 767px) {
      
        
      
    }
  }

  .fe-block-yui_3_17_2_1_1736191766798_659991 .sqs-block {
    justify-content: flex-start;
  }

  .fe-block-yui_3_17_2_1_1736191766798_659991 .sqs-block-alignment-wrapper {
    align-items: flex-start;
  }

  @media (min-width: 768px) {
    .fe-block-yui_3_17_2_1_1736191766798_659991 {
      grid-area: 295/2/300/26;
      z-index: 36;

      
        
      
    }

    .fe-block-yui_3_17_2_1_1736191766798_659991 .sqs-block {
      justify-content: flex-start;
    }

    .fe-block-yui_3_17_2_1_1736191766798_659991 .sqs-block-alignment-wrapper {
      align-items: flex-start;
    }
  }

</style><div class="fluid-engine fe-677c137a7d41546d3e83ebcb"><div class="fe-block fe-block-677c137a03baa38fe16bfef6" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-677c137a03baa38fe16bfef6"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h2 style="text-align: center; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0463768s;" class="preFade fadeIn"><strong>Privacy Notice</strong></h2><p style="text-align: center; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0492754s;" class="preFade fadeIn">(Last updated: January 1, 2025)</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-677c137a23a67f368ca40cd5"><div class="sqs-block horizontalrule-block sqs-block-horizontalrule" data-block-type="47" id="block-677c137a23a67f368ca40cd5"><div class="sqs-block-content"><hr></div></div></div><div class="fe-block fe-block-677c137a453cb625d377f836" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-677c137a453cb625d377f836"><div class="sqs-block-content">

<div class="sqs-html-content">
  <p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0521739s;">This Privacy Notice (“Notice”) is provided by Know Healthtech Inc. and its affiliates and subsidiaries, referred to in this Notice as “Know Healthtech,” “we,” “us” or “our.” This Notice applies to persons who use our app and/or our other online products and/or services (“users” or “you”) and informs you about personal data that we process, including what personal data we collect, and how we collect and use such personal data. This Notice also describes your rights and choices relating to your personal data.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0550725s;"><strong>In this Privacy Notice, you’ll learn about the following:</strong></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.057971s;"><a href="#background-data" target="">Background About Our Data Processing Activities</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0608696s;"><a href="#types-data">The Types of Data We Process</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0637681s;"><a href="#how-we-collect-data">How We Collect Data</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0666667s;"><a href="#why-we-process-data">Why We Process Data</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0695652s;"><a href="#your-personal-data">How We Share Data</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0724638s;"><a href="#cookies">Cookies and Other Tracking Technologies</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0753623s;"><a href="#data-analytics">Data Analytics</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0782609s;"><a href="#internet-ad" target="">Interest-Based Advertising</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0811594s;"><a href="#direct-marketing">Direct Marketing</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.084058s;"><a href="#rights-choices">Your Rights and Choices</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0869565s;"><a href="#data-security">Data Security</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0898551s;"><a href="#data-retention">Data Retention</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0927536s;"><a href="#minors">Privacy Statement for Minors</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0956522s;"><a href="#third-party-resources">Third-Party Resources</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.0985507s;"><a href="#consumer-health-data" target="_blank">Consumer Health Data</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.101449s;"><a href="#eu-uk-data-protection" target="">EU/UK Data Protection</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.104348s;"><a href="#updates">Updates to this Privacy Notice</a></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.107246s;"><a href="#contact">How to Contact Us</a></p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-677c137af7c7b60fb58a6fcf"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-677c137af7c7b60fb58a6fcf"><div class="sqs-block-content"><div id="background-data"></div></div></div></div><div class="fe-block fe-block-677c137abec535c48123a6e1" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-677c137abec535c48123a6e1"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.110145s;" class="preFade fadeIn"><strong>BACKGROUND ABOUT OUR DATA PROCESSING ACTIVITIES</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.113043s;">We offer certain online products and services, including but not limited to an app with features that allow you to use mental health journals, take surveys regarding your mental health, receive analytics reports about your use of our app and connect with mental health guides. These app features are referred to herein as “StoryCatch” and our online products and services (including StoryCatch) are referred to generally as our “Services.”</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.115942s;">We are committed to providing you with comprehensive and accurate information regarding our data practices. Accordingly, the aim of this Notice is to clearly explain how we collect, access, disclose, store, use and otherwise handle (“process”) data in connection with our Services and as otherwise described herein. If you have any questions about this Notice or our data practices, please feel free to contact us (see the “How to Contact Us” section at the end of this Notice).</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-677c137a8ee472804dd4f0da"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-677c137a8ee472804dd4f0da"><div class="sqs-block-content"><div id="types-data"></div>
</div></div></div><div class="fe-block fe-block-677c137a29825f4f36ae9159" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-677c137a29825f4f36ae9159"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.118841s;" class="preFade fadeIn"><strong>THE TYPES OF DATA WE PROCESS</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.121739s;">We process certain data regarding usage of our Services (“Usage Data”). Usage Data does not identify you and cannot reasonably be used to identify you. The Usage Data we process includes:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.124638s;">data about app pages visited by users;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.127536s;">the time spent by users on app pages;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.130435s;">source of traffic on our app (information about media referring user to our Services);</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.133333s;">actions such as downloads and clicks on links on our Services; and</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.136232s;">data about whether a user is a first-time or repeat user of our Services.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.13913s;">We also process certain data that identifies you or which may reasonably be used to identify you (“Personal Data”). The types of Personal Data we process include: </p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.142029s;"><strong>Identifiers and contact information</strong>, such as real name, aliases, address, email address, phone number and other similar identifiers, and contact information of users and their family members.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.144928s;"><strong>Health and medical information</strong>, such as information about diseases, symptoms, complications, therapies, medications, outcomes, barriers to access, and Consumer Health Data (as described further in the “Consumer Health Data” section below).</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.147826s;"><strong>Mental, emotional, and physical characteristics and conditions</strong>, such as level of fatigue, weight, mood, and any other characteristics or conditions that you may share through the Services, including in response to StoryCatch surveys.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.150725s;"><strong>Account information</strong>, such as username and password.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.153623s;"><strong>Demographic information</strong>, such as age, date of birth, and gender.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.156522s;"><strong>Inferences from Personal Data you share through our Services</strong>, such as notes about preferences, predispositions, behavior, attitudes, and aptitudes.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.15942s;"><strong>Internet or other electronic network activity information</strong>, such as IP address, country or geographic region location, device types, dates and times you access our Services, and other information about your interactions with our Services. We collect such information through cookies and other tracking technologies. Please see our “Cookies and Other Tracking Technologies” section below.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.162319s;">In addition to the above, we collect any other Personal Data that you provide to us in the course of using our Services, such as Personal Data you include in your journal entries and survey responses on StoryCatch.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_287416"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_287416"><div class="sqs-block-content"><div id="how-we-collect-data"></div>
</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_257127" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_257127"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.165217s;" class="preFade fadeIn"><strong>HOW WE COLLECT DATA</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.168116s;">We collect Usage Data and Personal Data in the following ways:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.171014s;"><strong>We collect Personal Data directly from you</strong>, such as when you use StoryCatch journaling or take StoryCatch surveys, when you apply for a clinical study, when you subscribe for updates regarding our Services, and when you contact us or request information from us.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.173913s;">We collect from your healthcare provider Personal Data which is included in your medical records in cases where you specifically authorize your provider to disclose such Personal Data to us.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.176812s;">We collect Usage Data automatically, such as through cookies or other technologies. We may also collect certain Personal Data (i.e., Internet or other electronic network activity information) automatically through cookies or other technologies.</p></li></ul>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_371061"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_371061"><div class="sqs-block-content"><div id="why-we-process-data">
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_299790" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_299790"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.17971s;" class="preFade fadeIn"><strong>WHY WE PROCESS DATA</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.182609s;">We process Usage Data to analyze the effectiveness of our Services and improve our Services, including without limitation, to optimize app features and make your use of our Services more convenient and user-friendly. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.185507s;">We process Personal Data for the business and commercial purposes described in the bullet points below.</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.188406s;"><strong>Providing our Services</strong>. To provide our Services, we may use any of the types of Personal Data described above, for example, identifiers and contact information, health and medical information, mental, emotional, and physical characteristics, and demographic information.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.191304s;"><strong>Communicating with you</strong>, for example, responding to your inquiries (including unsolicited requests for information about our clinical trials information) and providing direct marketing information to you in accordance with the terms of this Notice. For these purposes, we may use identifiers and contact information and any Personal Data included within your inquiry/request to us.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.194203s;"><strong>For our internal business purposes</strong>, for example, measuring the effectiveness of and improving our Services. For these purposes, we may use any of the types of Personal Data described above (but excluding Consumer Health Data), for example, identifiers and contact information and internet or other electronic network activity information.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.197101s;"><strong>Protecting rights and interests</strong>, for example, protecting the health, safety, and security of Know Healthtech and its employees, and persons who receive our Services; enforcing our legal rights; and pursuing remedies or otherwise taking steps to limit damages and liabilities. For these purposes, we may use any of the types of Personal Data described above, for example, identifiers and contact information to investigate violations of our contracts, or health and medical information in the event of an emergency. </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.2s;"><strong>Pursuant to your consent, for research purposes</strong> including without limitation, to enable third parties, such as researchers, statisticians, academic institutions and biopharmaceutical companies, to analyze data in connection with their research projects and/or to prepare research publications. For these purposes, we may process any of the types of Personal Data described above.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.202899s;"><strong>If applicable, in relation to and to effectuate a change in control of our business</strong>, including by means of merger, acquisition or purchase of all or substantially all of our assets. For these purposes, we may process any of the types of Personal Data described above.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.205797s;"><strong>As required by law and to meet our legal obligations</strong>, for example, by complying with orders from administrative or judicial authorities and complying with subpoenas and other legal process. For these purposes, we may process any of the types of Personal Data described above.</p></li></ul><p class="preFade fadeIn" data-rte-preserve-empty="true" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.208696s;"></p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_396126"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_396126"><div class="sqs-block-content"><div id="your-personal-data">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_404132" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_404132"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.211594s;" class="preFade fadeIn"><strong>HOW WE SHARE DATA</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.214493s;">We may share your Usage Data and Personal Data in the following ways:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.217391s;"><strong>We may share Usage Data and Personal Data with vendors and service providers</strong> who work on our behalf to provide certain services in support of our business operations and/or our Services, for example, entities that provide us with data storage, data analysis, and processing, IT and data security, and legal services. When we share Personal Data with vendors and service providers, we endeavor to require that they keep your Personal Data confidential and secure and process it for limited and specified purposes. </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.22029s;"><strong>We may share Usage Data and Personal Data with our affiliates and subsidiaries</strong>, for example, current and future companies within the Know Healthtech family of companies.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.223188s;"><strong>We may share Usage Data and Personal Data in connection with a business transfer</strong>, for example, as part of a sale, assignment, or transfer of a Know Healthtech business or asset group, or acquisition of or merger with another entity. We may also share your Personal Data in contemplation of such transactions, such as during due diligence. </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.226087s;"><strong>We may share Personal Data in response to requests from government or law enforcement agencies or where required or permitted by applicable laws, court orders, or government regulations</strong>, for example, in response to a subpoena or regulatory inquiry. </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.228986s;"><strong>We may share Personal Data to protect rights and interests</strong>, for example, when needed for corporate audits, to investigate or respond to a complaint or threat, or to exercise our legal rights.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.231884s;"><strong>With your consent, we may share Personal Data</strong> (including your health-related Personal Data) with a study center where you may potentially be able to participate in a clinical research study.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.234783s;">Additionally, with your consent, we may deidentify or anonymize your Personal Data and share deidentified/anonymous data with third parties, such as researchers, statisticians, academic institutions, and biopharmaceutical companies, so that they may analyze such data in connection with their research projects and/or to prepare research publications.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.237681s;">Your Personal Data collected through StoryCatch may also be shared if you choose to share it with others (e.g., family members, friends, caregivers, etc.). You solely control whether and with whom your Personal Data is shared when customizing your StoryCatch profile access settings, and to the extent you choose to share your Personal Data within StoryCatch, you accept sole responsibility for such sharing of Personal Data.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_476435"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_476435"><div class="sqs-block-content"><div id="cookies">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_465919" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_465919"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.24058s;" class="preFade fadeIn"><strong>COOKIES AND OTHER TRACKING TECHNOLOGIES</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.243478s;">We automatically process certain types of information whenever you interact with us on our Services and in some emails we may send to you. Automatic technologies we use may include, for example, cookies and web beacons.</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.246377s;"><strong>Cookies</strong>:&nbsp;A cookie is a piece of information that is placed on your computer when you access certain websites. The cookie uniquely identifies your browser to the server. Most web browsers are set up to accept cookies, though you can reset your browser to refuse all cookies or to indicate when a cookie is being sent. Note, however, that some portions of our Services may not work properly if you refuse cookies.</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.249275s;"><strong>Web Beacons</strong>:&nbsp;On certain parts of our Services or emails, we may utilize a common Internet technology called a “web beacon” (also known as a “pixel tag”, an “action tag”, or “clear GIF technology”). Web beacons help analyze the effectiveness of advertising campaigns and websites by measuring, for example, the number of visitors to a site or how many visitors clicked on key elements of a website.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.252174s;">Do Not Track (DNT) is a privacy preference that you can set in certain web browsers. Our Services may not recognize or respond to DNT signals, as the industry is currently working toward defining what DNT means and developing a common approach to responding to DNT signals. You can learn more about DNT&nbsp;<a href="https://fpf.org/thank-you-for-visiting-allaboutdnt-com/" target="_blank">here</a>.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_548357"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_548357"><div class="sqs-block-content"><div id="data-analytics">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_525053" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_525053"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.255072s;" class="preFade fadeIn"><strong>DATA ANALYTICS</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.257971s;">We may use third-party analytics services (such as Google Analytics) to process Usage Data. These analytics services help us improve the quality of our Services. To learn more about Google’s privacy practices, please review the&nbsp;<a href="https://policies.google.com/privacy?hl=en-US" target="_blank">Google Privacy Policy</a>. To prevent Google Analytics from using your information for analytics, you can install the Google Analytics Opt-Out Browser Add-on&nbsp;<a href="https://tools.google.com/dlpage/gaoptout" target="_blank">here</a>.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_620984"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_620984"><div class="sqs-block-content"><div id="internet-ad">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_572277" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_572277"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.26087s;" class="preFade fadeIn"><strong>INTEREST-BASED ADVERTISING</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.263768s;">Some of our online services may integrate third-party advertising technologies that allow for the delivery of relevant content and advertising on non-Know Healthtech services that you use. The ads on third-party services may be based on various factors, such as the content of the page you are visiting, your searches, demographic data, and your activities on our websites and third-party services. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.266667s;">We neither have access to, nor does this Notice govern, the use of cookies or other tracking technologies that may be placed on your device to access the services by non-affiliated third parties. To learn more about certain third-party trackers used for interest-based advertising, for example, through cross-device tracking, and to exercise certain choices regarding such technologies, please visit the&nbsp;<a href="https://optout.aboutads.info/?c=2&amp;lang=EN" target="_blank">Digital Advertising Alliance</a>&nbsp;(DAA),&nbsp;<a href="https://optout.networkadvertising.org/?c=1" target="_blank">Network Advertising Initiative</a> (NAI),&nbsp;<a href="https://youradchoices.ca/en/tools" target="_blank">Digital Advertising Alliance-Canada</a>,&nbsp;<a href="https://youronlinechoices.eu/" target="_blank">European Interactive Digital Advertising Alliance</a>, or your device settings if you have the DAA or other mobile app that allows you to control interest-based advertising on your device. We do not control these opt-out links or whether any particular company chooses to participate in these opt-out programs. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.269565s;">The opt-outs described at the links above are device- and browser-specific and may not work on all devices. If you clear cookies on your device or in your browser, you will have to go through the process of opting out again. If you choose to use any of these opt-out tools, this does not mean you will cease to see advertising. Rather, the ads you see will just not be based on your interests.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_703509"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_703509"><div class="sqs-block-content"><div id="direct-marketing">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_673017" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_673017"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.272464s;" class="preFade fadeIn"><strong>DIRECT MARKETING</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.275362s;">As noted above, we may process certain Personal Data, including your name and contact information, to send you direct marketing communications. These marketing communications may include, for example, newsletters, updates about our Services and other promotional materials that may be of interest to you. Our marketing communications include an unsubscribe option or other method by which you can opt out of receiving further marketing communications from us. You may also contact us at <a href="mailto:privacy@knowrare.com?" target="_blank">privacy@knowrare.com</a> at any time to request to opt out of receiving further marketing communications from us.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_799963"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_799963"><div class="sqs-block-content"><div id="rights-choices">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_762629" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_762629"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.278261s;" class="preFade fadeIn"><strong>YOUR RIGHTS AND CHOICES</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.281159s;">Depending on the jurisdiction in which you are located or reside, you may have certain rights with regard to your Personal Data. We will honor your rights in accordance with applicable laws and regulations, and we may verify your identity before responding to a request to exercise your rights. Please note that the rights described below may be subject to limitations under applicable laws and regulations. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.284058s;">To the extent provided for under applicable law, you may contact us at any time to:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.286957s;">Ask what Personal Data we process about you;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.289855s;">Request a copy of your Personal Data; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.292754s;">Request that we correct inaccurate or incomplete Personal Data;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.295652s;">Opt out of or suppress certain Personal Data processing;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.298551s;">Request deletion of your Personal Data;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.301449s;">Impose restrictions on our processing of your Personal Data; and </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.304348s;">Withdraw your consent to certain processing of your Personal Data.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.307246s;">You can exercise these rights by emailing us at&nbsp;<a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com</a>. You may also have the right to lodge a complaint with the privacy or data protection regulator in your state or country of residence.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.310145s;">If you are a “Consumer” (as defined in the “Consumer Health Data” section below), please refer to the Consumer Health Data section for additional information about your rights. If you are an individual in the EU or UK using our Services, please refer to the “EU/UK Data Protection” section below for further information about your rights.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_918654"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_918654"><div class="sqs-block-content"><div id="data-security">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_863741" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_863741"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.313043s;" class="preFade fadeIn"><strong>DATA SECURITY</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.315942s;">Know Healthtech has implemented privacy and security controls designed to help protect your Personal Data. Please note, however, that no security measures are 100% effective, and we cannot guarantee absolute security of your Personal Data. We encourage you to take steps to protect yourself, for example, by not sharing login credentials to your accounts, not sending us sensitive information using unsecure methods (e.g., via unencrypted email), and protecting your devices (e.g., with passwords).</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_1113583"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_1113583"><div class="sqs-block-content"><div id="data-retention">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_1005477" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_1005477"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.318841s;" class="preFade fadeIn"><strong>DATA RETENTION</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.321739s;">Know Healthtech retains your Personal Data for as long as necessary for the purpose for which it was collected, unless a longer period is required to comply with applicable laws. Our retention periods vary depending on the purpose(s) for which your Personal Data was collected. Some of the criteria we use to assess appropriate retention periods include: (1) the nature of the Personal Data and the activities involved, (2) when and for how long you interact with us, and (3) our legal obligations. To provide security and business continuity we make backups of certain data, which we may retain for longer than the original data.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_1189769"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_1189769"><div class="sqs-block-content"><div id="minors">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_1169916" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_1169916"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.324638s;" class="preFade fadeIn"><strong>PRIVACY STATEMENT FOR MINORS</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.327536s;">We do not knowingly collect Personal Data directly from children under 13 years old. In cases where we discover that we have collected Personal Data directly from a child under 13 years old, we will seek to promptly delete such Personal Data. &nbsp;Please contact us at <a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com</a> if you believe that we have collected Personal Data directly from any child under the age of 13.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_1364625"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736173028970_1364625"><div class="sqs-block-content"><div id="third-party-resources">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_1341709" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_1341709"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.330435s;" class="preFade fadeIn"><strong>THIRD-PARTY RESOURCES</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.333333s;">We may provide you with links to or information about third-party resources. For example, we may provide individuals with information about patient advocacy groups, and we may provide researchers with links to clinical trial registries. Please note that we do not control the privacy policies or practices of such third parties, and we encourage you to review the privacy notices of the third parties with which you interact.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736191766798_222473"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736191766798_222473"><div class="sqs-block-content"><div id="consumer-health-data">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736173028970_1387146" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736173028970_1387146"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.336232s;" class="preFade fadeIn"><strong>CONSUMER HEALTH DATA</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.33913s;">We process certain Consumer Health Data subject to U.S. state consumer health data privacy laws. This section explains the rights that may be exercised by individuals pursuant to such laws. As used in this Notice, “Consumer Health Data” means information that is linked or linkable to an identified or identifiable individual who is a resident of a U.S. state with an applicable consumer health data privacy law and which information identifies the individual’s past, present or future physical or mental health status (each such individual is referred to as a “Consumer”). </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.342029s;">To the extent of any inconsistency between terms under this Consumer Health Data section and terms elsewhere in this Notice, the terms under this Consumer Health section shall be controlling with regard to our processing of Consumer Health Data. </p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.344928s;" class="preFade fadeIn"><em>Categories of Consumer Health Data Collected</em> </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.347826s;">In connection with our Services, we may collect Consumer Health Data concerning:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.350725s;">individual health conditions, treatment, diseases, or diagnoses;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.353623s;">social, psychological, behavioral, or medical interventions; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.356522s;">health-related surgeries or procedures; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.35942s;">use or purchase of prescribed medication;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.362319s;">bodily functions or vital signs; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.365217s;">diagnoses or diagnostic testing, treatment, or medication; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.368116s;">gender-affirming care; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.371014s;">reproductive or sexual health; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.373913s;">biometric information;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.376812s;">genetic information;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.37971s;">precise geolocation that could reasonably indicate a Consumer’s attempt to acquire or receive health services or supplies; and </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.382609s;">a Consumer seeking health care services.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.385507s;">We do not permit any third party to collect Consumer Health Data over time across different Internet websites or online services when a Consumer uses our Services.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.388406s;" class="preFade fadeIn"><em>Sources from which Consumer Health Data is Collected</em></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.391304s;">We collect the categories of Consumer Health Data described above directly from Consumers.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.394203s;" class="preFade fadeIn"><em>Manner of Collecting and Processing Consumer Health Data</em></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.397101s;">Consumer Health Data is collected from Consumers when they share it through use of our Services. The Consumer Health Data that we collect is stored securely on servers maintained by third-party service providers with which we contract.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.4s;" class="preFade fadeIn"><em>Categories of Consumer Health Data Shared</em></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.402899s;">We share each of the categories of Consumer Health Data noted above with the categories of third parties identified below.</p><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.405797s;" class="preFade fadeIn"><em>Categories of Third Parties with which Consumer Health Data is Shared</em></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.408696s;">We share Consumer Health Data with the following categories of third parties: </p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.411594s;">Service providers that assist us with providing our Services </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.414493s;">Study centers where you may potentially be able to participate in a clinical research study, where you have consented to such sharing</p></li></ul><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.417391s;" class="preFade fadeIn"><em>Purposes of Processing Consumer Health Data</em></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.42029s;">The purposes of processing Consumer Health Data are as follows:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.423188s;">We process Consumer Health Data to provide our Services to you; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.426087s;">We process Consumer Health Data to improve our Services or to develop new products or services; and </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.428986s;">With your separate consent, we anonymize your Consumer Health Data and share the anonymous data with researchers, statisticians, academic institutions, and biopharmaceutical companies so that they may analyze such data in connection with their research projects and/or prepare research publications.</p></li></ul><p style="margin-left: 40px; white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.431884s;" class="preFade fadeIn"><em>Consumer Rights</em></p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.434783s;">Consumers have certain rights under U.S. state consumer health data privacy laws with respect to Consumer Health Data about them. Such rights may include the following:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.437681s;">A Consumer may request confirmation of whether we are collecting, sharing, or selling Consumer Health Data and to access such Consumer Health Data;</p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.44058s;">A Consumer may request a list of all third parties with whom we have shared Consumer Health Data or to whom we have sold Consumer Health Data and may also request an active email address or other online mechanism that the Consumer may use to contact these third parties; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.443478s;">A Consumer may withdraw consent for our collection and sharing of Consumer Health Data; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.446377s;">A Consumer may request deletion of Consumer Health Data; and </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.449275s;">A Consumer may request that we stop collecting, sharing, or selling Consumer Health Data.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.452174s;">If you are a Consumer who wishes to exercise any of the rights noted above, you may submit a request to us at <a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com</a>.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.455072s;">If you’ve made a request to exercise any of your rights noted above and we deny the request, you have the right to appeal that denial. If you would like to appeal a denial of your request, please contact us at <a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com</a>. When you contact us to appeal the denial, please describe the specific reasons why you believe your request should be granted. Within 45 days of our receipt of your appeal, we will respond in writing describing any action taken or not taken on your appeal, including a written explanation of the reason for our decision. If your appeal is denied, we will notify you of a method through which you may contact the attorney general in your state to submit a complaint.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736191766798_372712"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736191766798_372712"><div class="sqs-block-content"><div id="eu-uk-data-protection">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736191766798_269097" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736191766798_269097"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.457971s;" class="preFade fadeIn"><strong>EU/UK DATA PROTECTION</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.46087s;">In addition to other terms and conditions of this Notice, the following terms apply to individuals who use our Services in the European Union (EU) or United Kingdom (UK). </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.463768s;">Know Healthtech is a “controller” of Personal Data that you share through your use of our Services (i.e., Know Healthtech is the entity that determines the purposes and means of processing such Personal Data). </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.466667s;">As described in this Notice, we process this Personal Data for various purposes, including without limitation, to provide our Services. Please refer to the section above titled “Why We Process Data” for a full description of the purposes for which we process Personal Data. Additionally, for information about the categories of recipients of your Personal Data, please refer to the “How We Share Data” section above, and for information about our retention of Personal Data, please refer to the “Data Retention” section above. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.469565s;">We may process Personal Data on one or more of the following legal bases:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.472464s;">Your consent; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.475362s;">When processing the Personal Data is necessary for compliance with a legal obligation to which we are subject; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.478261s;">When processing the Personal Data is necessary for purposes of carrying out our legitimate interests in maintaining network and information security and detecting and preventing against fraud and other malicious activity in relation to our Services, where such interests are not are overridden by your interests or fundamental rights and freedoms; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.481159s;">When processing the Personal Data is necessary in order to protect the vital interests of the subject of the Personal Data or of another natural person; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.484058s;">When processing the Personal Data is necessary for scientific research purposes based on EU law, Member State law or applicable law in the UK; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.486957s;">When processing the Personal Data is necessary for the establishment, exercise or defense of legal claims; and/or </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.489855s;">When our processing relates to Personal Data which has been made public by the subject of the Personal Data.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.492754s;">As a subject of Personal Data (“data subject”), you have the right to request access to, rectification of, erasure of, and/or restriction of processing of your Personal Data. You also have the right to object to further processing of your Personal Data or to request that your Personal Data be transferred to another controller. To exercise any of these rights, you may contact us at <a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com</a>. We will respond to you as required by applicable law.</p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.495652s;">If our processing of your Personal Data is based on your consent, you may withdraw your consent to such processing at any time by contacting us at privacy@knowrare.com, however, your withdrawal will not affect the lawfulness of processing that occurred before our receipt of your withdrawal. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.498551s;">You are not required to provide us with your Personal Data, but if you choose not to provide your Personal Data, you may not be able to use some or all of our Services. </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.501449s;">As needed in connection with providing our Services or carrying out other purposes described in this Notice, we may transfer Personal Data from the European Economic Area (EEA) or UK to the United States and we may engage in such transfers on one or more of the following bases:</p><ul data-rte-list="default"><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.504348s;">Your explicit consent to the transfer. In the event we rely on your explicit consent for transferring your Personal Data, please note that neither the European Commission nor the UK government has determined that the United States offers an adequate level of protection of Personal Data. Your Personal Data may therefore be at greater risk once it is transferred to the United States due to the absence of this determination of an adequate level of protection and lack of safeguards to protect the Personal Data. Despite the foregoing, we will take reasonable and appropriate measures to protect your Personal Data in accordance with the terms of this Notice. You have the right to withdraw your consent to the transfer of your Personal Data, and if you wish to exercise this right, you may contact us at <a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com;</a></p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.507246s;">Standard data protection clauses which set forth certain protections to be applied to the Personal Data being transferred. In the event we use such standard data protection clauses, you may contact us at <a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com</a> to request a copy of these clauses; </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.510145s;">Where the transfer is necessary for the establishment, exercise or defense of legal claims; and </p></li><li><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.513043s;">Where the transfer is necessary in order to protect your or another person’s vital interests, and where you are physically or legally incapable of giving consent.</p></li></ul><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.515942s;">If you have a concern with how your Personal Data is processed, you may lodge a complaint with a data protection authority in the country in which you are located. A list of EU data protection authorities and their contact information can be found here: <a href="https://edpb.europa.eu/about-edpb/board/members_en" target="_blank">https://edpb.europa.eu/about-edpb/board/members_en</a>. If you are in the UK, you may contact the UK Information Commissioner’s Office at: <a href="https://ico.org.uk/make-a-complaint/" target="_blank">https://ico.org.uk/make-a-complaint/</a>. You may also contact us at privacy@knowrare.com so that we may attempt to address your concern.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736191766798_688434"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736191766798_688434"><div class="sqs-block-content"><div id="updates">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736191766798_427515" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736191766798_427515"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.518841s;" class="preFade fadeIn"><strong>UPDATES TO THIS PRIVACY NOTICE</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.521739s;">We may change this Notice from time to time, and we will post any changes to this Notice online. The date on which this notice was last updated is included at the beginning of this Notice. We may not notify you individually of any changes to this Notice, so you should check back occasionally to ensure that you are aware of the most recent version.</p>
</div>




















  
  



</div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736191766798_974703"><div class="sqs-block code-block sqs-block-code" data-block-type="23" id="block-yui_3_17_2_1_1736191766798_974703"><div class="sqs-block-content"><div id="contact">
  
</div></div></div></div><div class="fe-block fe-block-yui_3_17_2_1_1736191766798_659991" style="mix-blend-mode: normal;"><div class="sqs-block html-block sqs-block-html" data-blend-mode="NORMAL" data-block-type="2" data-border-radii="{&quot;topLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;topRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomLeft&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0},&quot;bottomRight&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;value&quot;:0.0}}" id="block-yui_3_17_2_1_1736191766798_659991"><div class="sqs-block-content">

<div class="sqs-html-content">
  <h3 style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.524638s;" class="preFade fadeIn"><strong>HOW TO CONTACT US</strong></h3><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.527536s;">Questions or comments about our privacy practices may be directed as follows: </p><p class="preFade fadeIn" style="white-space: pre-wrap; transition-timing-function: ease; transition-duration: 1.5s; transition-delay: 0.530435s;"><a href="https://emailto:privacy@knowrare.com" target="_blank">privacy@knowrare.com</a></p>
</div>




















  
  



</div></div></div></div></div>
    </div>`,
  ccpaText: `<div class="sqs-html-content">
  <p class="" style="white-space: pre-wrap">&nbsp;<br /></p>
  <h2 style="text-align: center; white-space: pre-wrap">
    <strong>Know Healthtech Inc. California Consumer Privacy Act Notice</strong>
  </h2>
  <p style="text-align: center; white-space: pre-wrap" class="">
    <strong>(Last updated: September 1, 2020)</strong>
  </p>
  <p class="" style="white-space: pre-wrap">
    This California Consumer Privacy Act Notice (“Notice”) is provided by Know
    Healthtech Inc. and its affiliates and subsidiaries, referred to in this
    Notice as “we,” “us” or “our.” This Notice supplements the information
    contained in our general Privacy Policy as posted and updated from time to
    time. This Notice applies solely to visitors, users, and others who reside
    in the State of California (“consumers” or “you”) when you visit our website
    or subscribe to receive our services.
  </p>
  <p class="" style="white-space: pre-wrap">
    This Notice explains how we collect, use, and disclose personal information
    about California residents. This Notice also explains certain rights that
    California residents have under the California Consumer Privacy Act
    (“CCPA”). This Notice explains how California residents can exercise their
    rights under the CCPA to request that we: (1) provide certain personal
    information that we have collected about them during the past 12 months,
    along with related information described below, or (2) delete certain
    personal information that we have collected from them. Any terms defined in
    the CCPA have the same meaning when used in this Notice.
  </p>
  <p class="" style="white-space: pre-wrap">
    Under the CCPA, “personal information” is information that identifies,
    relates to, describes, is reasonably capable of being associated with, or
    could reasonably be linked, directly or indirectly, with a particular
    California resident or household. This information is referred to in this
    Notice as “Personal Data.”
  </p>
  <ol data-rte-list="default">
    <li>
      <h3 style="white-space: pre-wrap">
        <strong
          >Categories of Personal Data that We Collect and Disclose</strong
        >
      </h3>
    </li>
  </ol>
  <p class="" style="white-space: pre-wrap">
    We collect, use, process, and disclose information that identifies, relates
    to, describes, is reasonably capable of being associated with, or could
    reasonably be linked, directly or indirectly, with a particular consumer or
    device. The Personal Data that we collect, use, or disclose about a specific
    California resident will depend on, for example, our relationship or
    interaction with that individual.
  </p>
  <p class="" style="white-space: pre-wrap">
    During the past 12 months, we have collected the following categories of
    Personal Data:
  </p>
  <ul data-rte-list="default">
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Identifiers</strong>, such as a real name, alias, postal
        address, unique personal identifier, online identifier, internet
        protocol (IP) address, email address, account name, social security
        number, driver’s license or state identification card number, passport
        number, or other similar identifiers.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Customer Records</strong>, such as physical characteristics or
        description, telephone number, bank account number, credit card number,
        debit card number, or any other financial information.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Personal Characteristics or Traits</strong>, such as demographic
        data, age, ethnicity, citizenship, national origin, religion, creed,
        marital status, physical illness, mental illness or disabilities, gender
        (including gender identity and gender expression), sexual orientation,
        or marital Status.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Customer Account Details/Commercial Information</strong>, such
        as records of personal property, products or services purchased,
        obtained, or considered, or other purchasing or consuming histories or
        tendencies.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Internet Usage Information</strong>, such as browsing history,
        search history, and information regarding a consumer’s interaction with
        our website, application or advertisement.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Biometric Information</strong>, such as physiological,
        biological, or behavioral characteristics that can be used, singly or in
        combination with each other or with other identifying data, to establish
        individual identity, including imagery of the iris, retina, fingerprint,
        face, hand, palm, vein patterns, voice recordings, keystroke patterns or
        rhythms, gait patterns or rhythms, and sleep, health, or exercise data
        that contain identifying information.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Geolocation Data</strong>, such as physical location or
        movements and travel patterns.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Sensory Data</strong>, such as audio, electronic, visual, or
        similar information, including recordings of customer service
        calls.&nbsp;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        <strong>Inferences derived from your other Personal Data</strong>, such
        as information about your preferences, characteristics, psychological
        trends, predispositions, behavior, attitudes, intelligence, abilities,
        and aptitudes.
      </p>
    </li>
  </ul>
  <p class="" style="white-space: pre-wrap">
    Please note that we may not collect each of these categories about every
    consumer.
  </p>
  <p class="" style="white-space: pre-wrap">
    Personal Data, however, does not include:
  </p>
  <ul data-rte-list="default">
    <li>
      <p class="" style="white-space: pre-wrap">
        Publicly available information from federal, state, or local government
        records.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        De-identified or aggregated consumer information.
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        Information excluded from the CCPA's scope, like:
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        Health or medical information covered by the Health Insurance
        Portability and Accountability Act of 1996 (HIPAA) and the California
        Confidentiality of Medical Information Act (CMIA) or clinical trial
        data; or
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        Personal information covered by certain sector-specific privacy laws,
        including the Fair Credit Reporting Act (FRCA), the Gramm-Leach-Bliley
        Act (GLBA) or California Financial Information Privacy Act (FIPA), and
        the Driver's Privacy Protection Act of 1994.
      </p>
    </li>
  </ul>
  <h3 style="white-space: pre-wrap">
    <strong>2. Why We Collect Personal Data and How We Use It</strong>
  </h3>
  <p class="" style="white-space: pre-wrap">
    The purposes for which we collect and use Personal Data depend on, among
    other things, our relationship or interaction with a specific California
    resident. The table below lists the purposes for which we collect and use
    Personal Data in different contexts.
  </p>
</div>
`,
  hipaaText: `<div class="sqs-block-content">
<div class="sqs-html-content">
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <h2 style="text-align: center; white-space: pre-wrap">
    HIPAA Authorization
  </h2>
  <p style="text-align: center; white-space: pre-wrap" class="">
    <strong>Know Healthtech, Inc. HIPAA Authorization</strong>
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    Know Healthtech, Inc.’s platform assists you in finding and learning about
    clinical studies appropriate for your medical condition, helps you
    schedule screening visits with a clinical research project (a “Study
    Center”) and forwards your health-related information to share with the
    Study Center (“Know Healthtech, Inc. Services”). As part of providing the
    Know Healthtech, Inc. Services, Know Healthtech, Inc. may collect, use,
    share, and exchange your health-related information with a Study
    Center.&nbsp;
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    <strong>Application of HIPAA to your Information</strong>
  </p>
  <p class="" style="white-space: pre-wrap">
    The federal law known as the Health Insurance Portability and
    Accountability Act (“HIPAA”) provides certain protections to your
    health-related information that is identifiable to you (such information
    covered by HIPAA is known as “protected health information” or its
    initials, “PHI”). Generally, only health plans, clearing houses and
    certain health care providers are subject to HIPAA (a “Covered
    Entity”).&nbsp; A Study Center in most cases would be a Covered Entity.
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    Know Healthtech, Inc. is
    <span style="text-decoration: underline">not</span> a Covered Entity.
    However, we are required by law to maintain the privacy and security of
    your PHI to the extent that we provide certain types of assistance to a
    Covered Entity (which would make us a “Business Associate” of the Covered
    Entity). Thus, to the extent that your personal health information is
    obtained by us by our acting as a Business Associate to a Covered Entity,
    that information is PHI.
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    <strong>Non-Protected Health Information</strong>
  </p>
  <p class="" style="white-space: pre-wrap">
    As a condition of creating your Know Healthtech, Inc. account, you are
    required to read and agree to Know Healthtech, Inc.’s Privacy Policy. Know
    Healthtech, Inc.’s Privacy Policy explains how Know Healthtech, Inc.
    processes and shares information received from you that is not covered by
    HIPAA (“Non-PHI”).
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    <strong>Your PHI Authorization</strong>
  </p>
  <p class="" style="white-space: pre-wrap">
    The purpose of this Know Healthtech, Inc. HIPAA Authorization
    (“Authorization”) is to request your written permission to allow Know
    Healthtech, Inc. to use and disclose your PHI in the same way as we use
    and disclose your Non-PHI. If Know Healthtech, Inc. is a Business
    Associate of a Study Center or other Covered Entity, it may use the PHI
    when it is working on behalf of a Study Center or other Covered Entity.
    Know Healthtech, Inc. needs your authorization to be able to use and
    disclose your PHI in the same way it can currently use and disclose your
    Non-PHI when Know Healthtech, Inc. is working on its own behalf.&nbsp;
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    If you electronically sign this Authorization, you give your permission to
    Know Healthtech, Inc. to retain your PHI and to use and/or disclose your
    PHI in the same way that you have agreed that your Non-PHI can be used and
    disclosed. Once you provide this Authorization, the HIPAA requirements
    that apply to Business Associates will not apply to such uses and
    disclosures.
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    Specifically, you agree that Know Healthtech, Inc. can use your PHI to:
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <ul data-rte-list="default">
    <li>
      <p class="" style="white-space: pre-wrap">
        enable and customize your use of the Know Healthtech, Inc. Services;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        provide you alerts or other Know Healthtech, Inc. Services regarding
        future appointments;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        notify you regarding clinical studies, pharmaceuticals, or health care
        providers we think you may be interested in learning more about;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        share information with you regarding services, therapies, products or
        resources about which we think you may be interested in learning more;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        provide you with updates and information about the Know Healthtech,
        Inc. Services;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        market to you about Know Healthtech, Inc. and third-party products and
        services;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        conduct analysis for Know Healthtech, Inc.’s business purposes;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        support development of the Know Healthtech, Inc. Services;&nbsp;
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        create de-identified information and then use and disclose this
        information in any way permitted by law, including to third parties in
        connection with their commercial and marketing efforts; and
      </p>
    </li>
    <li>
      <p class="" style="white-space: pre-wrap">
        share information with third parties assisting Know Healthtech, Inc.
        with any of the uses described above.
      </p>
    </li>
  </ul>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap"><strong>Redisclosure</strong></p>
  <p class="" style="white-space: pre-wrap">
    Your PHI which may be disclosed pursuant to this Authorization is subject
    to redisclosure by us and would no longer be protected by HIPAA. While
    Know Healthtech, Inc. will require that the person or entity receiving
    your PHI agrees to only use and disclose your PHI to carry out its
    specific business obligations to Know Healthtech, Inc. or for the
    permitted purpose of the disclosure, Know Healthtech, Inc. cannot
    guarantee that any such person or entity to which Know Healthtech, Inc.
    discloses your PHI or other information will not re-disclose it in ways
    that you or we did not intend or permit.
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    <strong>Expiration and Revocation of Authorization</strong>
  </p>
  <p class="" style="white-space: pre-wrap">
    Your Authorization remains in effect until you provide written notice of
    revocation to Know Healthtech, Inc..
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    YOU MAY REVOKE (TAKE BACK) THIS AUTHORIZATION AT ANY TIME.
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    If you wish to revoke this Authorization, you must notify Know Healthtech,
    Inc. by submitting a revocation through your account settings page. Your
    decision not to execute this Authorization or to revoke it at any time
    will not affect your ability to use the Know Healthtech, Inc. Services.
    Once Know Healthtech, Inc. receives your Revocation of Authorization, Know
    Healthtech, Inc. can only use and disclose your PHI as permitted in Know
    Healthtech, Inc.’s agreements with a Study Center.&nbsp;
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
  <p class="" style="white-space: pre-wrap">
    A Revocation of Authorization is effective after you submit it to Know
    Healthtech, Inc., but it does not have any effect on Know Healthtech,
    Inc.’s prior actions taken in reliance on the Authorization before
    revoked.
  </p>
  <p
    class=""
    data-rte-preserve-empty="true"
    style="white-space: pre-wrap"
  ></p>
</div>
</div>
`,
};
